import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NewUserData, PaginatedUsers, SearchUsersParameters, UpdateUserData, User } from '../models/Users.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);

  private apiUrl = `${APP_CONFIG.API_URL}/user`;

  public getUsers(searchParameters: SearchUsersParameters = {}): Observable<PaginatedUsers> {
    let params = new HttpParams();
    Object.entries(searchParameters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value.toString());
      }

    });
    return this.http.get<PaginatedUsers>(this.apiUrl + '/all', {params});
  }

  public getSelf(): Observable<User> {
    return this.http.get<User>(this.apiUrl + '/me');
  }

  public createUser(userData: NewUserData): Observable<User> {
    return this.http.post<User>(this.apiUrl, userData);
  }

  public updateUser(userData: UpdateUserData): Observable<User> {
    return this.http.put<User>(this.apiUrl, userData);
  }

  public updateRoles(userId: string, roleIds: number[]): Observable<User> {
    return this.http.put<User>(this.apiUrl + `/${userId}/roles`, roleIds);
  }

  public approveUsers(userIds: string[]): Observable<void> {
    return this.http.post<void>(this.apiUrl + '/approve', userIds);
  }

  public declineUsers(userIds: string[]): Observable<void> {
    return this.http.post<void>(this.apiUrl + '/decline', userIds);
  }

  public deleteUsers(userIds: string[]): Observable<void> {
    return this.http.delete<void>(this.apiUrl, {body: userIds});
  }
}
